// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Switch__container-d67a6d {
  width: 36px;
  height: 22px;
  padding: 2px;
  border-radius: 15px;
  background-color: var(--base-50);
  box-sizing: border-box;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.Switch__active-container-b2f238 {
  background-color: var(--brand-primary-40);
}

.Switch__disabled-container-a9c8a9 {
  background-color: var(--base-30);
  &.Switch__active-container-b2f238 {
    background-color: var(--brand-primary-20);
  }
}

.Switch__thumb-b6c135 {
  width: 18px;
  height: 18px;
  background-color: var(--addition-50);
  border-radius: 50%;
  transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.Switch__active-thumb-b8d0da {
  transform: translateX(14px);
}

:root[dir=rtl] .Switch__active-thumb-b8d0da {
  transform: translateX(-14px);
}

.Switch__disabled-thumb-e1b2a2 {
  background-color: var(--base-10);
}

.Switch__disabled-thumb-e1b2a2.Switch__active-thumb-b8d0da {
  background-color: var(--brand-primary-10);
}

.Switch__checkbox-f19857 {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Switch/Switch.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,sBAAA;EACA,mEAAA;AACF;;AAEA;EACE,yCAAA;AACF;;AAEA;EACE,gCAAA;EAEA;IACE,yCAAA;EAAF;AACF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,4DAAA;AAAF;;AAGA;EACE,2BAAA;AAAF;;AAGA;EACE,4BAAA;AAAF;;AAGA;EACE,gCAAA;AAAF;;AAGA;EACE,yCAAA;AAAF;;AAGA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAAF","sourcesContent":[".container {\n  width: 36px;\n  height: 22px;\n  padding: 2px;\n  border-radius: 15px;\n  background-color: var(--base-50);\n  box-sizing: border-box;\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n\n.active-container {\n  background-color: var(--brand-primary-40);\n}\n\n.disabled-container {\n  background-color: var(--base-30);\n\n  &.active-container {\n    background-color: var(--brand-primary-20);\n  }\n}\n\n.thumb {\n  width: 18px;\n  height: 18px;\n  background-color: var(--addition-50);\n  border-radius: 50%;\n  transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n\n.active-thumb {\n  transform: translateX(14px);\n}\n\n:root[dir='rtl'] .active-thumb {\n  transform: translateX(-14px);\n}\n\n.disabled-thumb {\n  background-color: var(--base-10);\n}\n\n.disabled-thumb.active-thumb {\n  background-color: var(--brand-primary-10);\n}\n\n.checkbox {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Switch__container-d67a6d`,
	"active-container": `Switch__active-container-b2f238`,
	"activeContainer": `Switch__active-container-b2f238`,
	"disabled-container": `Switch__disabled-container-a9c8a9`,
	"disabledContainer": `Switch__disabled-container-a9c8a9`,
	"thumb": `Switch__thumb-b6c135`,
	"active-thumb": `Switch__active-thumb-b8d0da`,
	"activeThumb": `Switch__active-thumb-b8d0da`,
	"disabled-thumb": `Switch__disabled-thumb-e1b2a2`,
	"disabledThumb": `Switch__disabled-thumb-e1b2a2`,
	"checkbox": `Switch__checkbox-f19857`
};
module.exports = ___CSS_LOADER_EXPORT___;
